import { Box, Flex } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router-dom';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { PermissionGuard, PermissionsFn } from '~/core/PermissionGuard';
import { Typography } from '~/packages/common-frontend/components/Typography';
import { OmniEmbedContainer } from '~/packages/omni/ui/OmniEmbedContainer';

// Fragments
const RouteBase = () => {
  const { user } = useUserAuthOrThrow();

  return (
    <Box h="100%" w="100%">
      <Flex justify="space-between" w="100%" mb="6">
        <Typography variant="page-title" trim>
          Analytics V2
        </Typography>
      </Flex>

      <OmniEmbedContainer
        organizationId={user.organization.id}
        height="calc(100vh - 200px)"
      />
    </Box>
  );
};

// Exports
export const permissions: PermissionsFn = (context) => {
  if (['valleyBank', 'valleyBankSls'].includes(context.user.organization.slug))
    return 'deny';
  return context.flags.productsOmniAnalyticsPermissions;
};

export const Route = () => {
  return (
    <PermissionGuard
      permissions={permissions}
      fallback={<Navigate to="/" replace />}
    >
      <RouteErrorBoundary
        fallback={({ message, showErrorToast }) => {
          showErrorToast(message);
          return <Navigate to="/" />;
        }}
      >
        <Flex
          direction="column"
          padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}
          id="omni-analytics-route-container"
        >
          <RouteBase />
        </Flex>
      </RouteErrorBoundary>
    </PermissionGuard>
  );
};
